import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ConfluencePagePreviewPanelProps } from './ui/confluence-page-preview-panel';

export const confluencePagePreviewPanelEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		ConfluencePagePreviewPanelProps,
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "confluence-preview-panel-entrypoint" */ './ui/confluence-page-preview-panel/main'
			),
		{
			moduleId: 'confluence-preview-panel-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
